import { MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { useContext } from 'react'

import { MinterEventsContext } from '../../../Contexts'

const EventTypeFilter: React.FC = () => {
  const { eventType, updateEventType } = useContext(MinterEventsContext)

  const onFilterChange = (event: SelectChangeEvent<string>) => {
    updateEventType?.(event.target.value)
  }

  return (
    <Select onChange={onFilterChange} value={eventType} variant="standard">
      <MenuItem value={'All'}>All</MenuItem>
      <MenuItem value={'AuctionStarted'}>Auction Started</MenuItem>
      <MenuItem value={'BidPlaced'}>Bid Placed</MenuItem>
      <MenuItem value={'GeotokenMinted'}>Geotoken Minted</MenuItem>
      <MenuItem value={'MintingFeeSent'}>Minting Fee Sent</MenuItem>
      <MenuItem value={'RefundedCurrentBid'}>Refunded Current Bid</MenuItem>
      <MenuItem value={'TokensBurned'}>Tokens Burned</MenuItem>
      <MenuItem value={'TokensFlowed'}>Tokens Flowed</MenuItem>
    </Select>
  )
}

export default EventTypeFilter
